<ngb-accordion #acc="ngbAccordion">
	<ngb-panel title="Indice">
		<ng-template ngbPanelContent>
			<app-topics
            [topics]="topics"
				[accordion]="acc"></app-topics>
		</ng-template>
	</ngb-panel>

</ngb-accordion>